//
import jsPDF from 'jspdf'
import 'jspdf-autotable'

/**
 *
 */
export default function({ body, name, folio }) {
    //
    const heads = [
        '#',
        'Fecha',
        'Tipo',
        'Folio',
        'Rut',
        'Razón social',
        //'Teléfono',
        'Dirección',
        'Valor',
        'Condición de pago',
    ]

    //
    const doc = new jsPDF('l', 'mm', 'legal')

    //
    doc.autoTable({
        head: [heads],
        body,
        didDrawPage(data) {
            //
            doc.setDrawColor(40, 40, 40)
            doc.setTextColor(40)

            // header title
            doc.setFontSize(15)
            doc.setFontStyle('normal')
            doc.text(
                'Reporte Guía de Transporte',
                data.settings.margin.left + 100,
                20
            )

            // header title
            doc.setFontSize(10)
            doc.setFontStyle('normal')
            doc.text(
                'FECHA: ' + new Date().toLocaleDateString(),
                data.settings.margin.left + 239,
                20
            )

            // header title
            doc.setFontStyle('normal')
            doc.text('FOLIO: ' + folio, data.settings.margin.left, 30)

            // header title
            doc.setFontStyle('normal')
            doc.text('PATENTE DE CAMION: ', data.settings.margin.left, 35)

            doc.setFontStyle('normal')
            doc.text('CONDUCTOR: ', data.settings.margin.left + 95, 35)

            doc.setFontStyle('normal')
            doc.text('ASISTENTE: ', data.settings.margin.left + 180, 35)

            //
            doc.setFontStyle('normal')
            doc.text(
                'FIRMA ENCARGADO DE DESPACHO',
                data.settings.margin.left + 25,
                195
            )

            //
            doc.setFontStyle('normal')
            doc.text(
                'FIRMA ENCARGADO DE TRANSPORTE',
                data.settings.margin.left + 175,
                195
            )

            //
            doc.line(55, 35, 105, 35)
            doc.line(140, 35, 190, 35)
            doc.line(220, 35, 280, 35)

            //
            doc.line(20, 190, 120, 190)
            doc.line(170, 190, 270, 190)
        },
        //startY: 0,
        theme: 'striped',
        columnStyles: {
            0: { columnWidth: 5 },
            1: { columnWidth: 10 },
            2: { columnWidth: 5 },
            3: { columnWidth: 12 },
            4: { columnWidth: 23 },
            5: { columnWidth: 5 },
            6: { columnWidth: 10 },
            7: { columnWidth: 5 },
            8: { columnWidth: 10 },
        },
        margin: {
            top: 40, 
            bottom: 40,
        },
    })

    //
    doc.save('REPORTE GUÍA DE TRANSPORTE - ' + String(name) + '.pdf')
}
